export default __webpack_public_path__ + "static/media/P-027.2340fa23.png";